import { useMutation } from "react-query";
import submitSkuPoOcr from "../services/submitSkuPoOcr";

const useSubmitSkuPoOcr = () => {
  return useMutation(["submit-sku-po-ocr"], submitSkuPoOcr);
};

export default useSubmitSkuPoOcr;
